import React from "react";
import Select from "react-select";

export const getLobColors = (lob) => {
  if (lob === "HN") {
    return "tw-bg-green-100 tw-text-green-700";
  } else if (lob === "SCP") {
    return "tw-bg-blue-100 tw-text-blue-700";
  } else if (lob === "PAC") {
    return "tw-bg-red-100 tw-text-red-700";
  } else {
    return "tw-bg-gray-100 tw-text-gray-700";
  }
};

export const getStatusColor = (status) => {
  if (status === "One") {
    return "tw-bg-red-100 tw-text-red-500"; // One in red
  } else if (status === "Two") {
    return "tw-bg-yellow-100 tw-text-yellow-600"; // Two in orange
  } else if (status === "Three") {
    return "tw-bg-green-100 tw-text-green-700"; // Three in green
  }
  return "";
};

export const getStatusLabel = (status) => {
  if (status === "One") {
    return "HR: Tier 1"; // One -> HR: Tier 1
  } else if (status === "Two") {
    return "HR: Tier 2"; // Two -> HR: Tier 2
  } else if (status === "Three") {
    return "HR: Tier 3"; // Three -> HR: Tier 3
  }
  return "";
};

export const formatOptionLabel = ({ label }, meta) => {
  const isSelected = meta
    ? meta.selectValue[0]?.label === label && meta.context === "menu"
    : "";

  if (!label) {
    return null;
  }

  const labelParts = label.split(" - ");
  const namePart = labelParts[0];
  const dobPart = labelParts[1];
  const lobPart = labelParts[2];
  const highRiskPart = labelParts[3];
  const rcaPart = labelParts.length === 5 ? labelParts[4] : labelParts[3];

  return (
    <div className="tw-flex tw-space-x-3 tw-items-baseline">
      <div className={`${isSelected ? "tw-text-white" : "tw-text-gray-900"}`}>
        {namePart}{" "}
      </div>
      <div
        className={`${
          isSelected ? "tw-text-gray-100" : "tw-text-gray-500"
        } tw-text-sm`}
      >
        {dobPart}
      </div>
      {lobPart && (
        <div
          className={`tw-py-0.5 tw-px-2 tw-text-xs tw-rounded ${getLobColors(
            lobPart
          )}`}
        >
          {lobPart}
        </div>
      )}
      {highRiskPart && (
        <div
          className={`tw-py-0.5 tw-px-2 tw-text-xs tw-rounded ${getStatusColor(
            highRiskPart
          )}`}
        >
          {getStatusLabel(highRiskPart)}
        </div>
      )}
      {rcaPart && (
        <div className={`tw-text-red-500 tw-text-sm`}>
          {rcaPart === "(Complete RCA)" ? rcaPart : ""}
        </div>
      )}
    </div>
  );
};

const MyCustomSelect = ({
  isRequired,
  mode,
  disable,
  errorMessage,
  selectOptions,
  name,
  marginb,
  selectedValue,
  defaultOption,
  isMulti,
  myCallBack,
  index,
  formatOptionLabel,
  placeholderText,
  menuPortalTarget,
  id,
  defaultValue,
}) => {
  const onChange = (option, actionMeta) => {
    myCallBack(option, index);
  };

  const filterOptions = (input, option) =>
    (input?.label ?? "").toLowerCase().includes(option?.toLowerCase());

  const customStyles = {
    container: (base, state) => ({
      ...base,
      outline: "none",
    }),
    control: (base, state) => ({
      ...base,
      // state.isFocused can display different borderColor if you need it
      borderColor: state.isFocused ? "blue" : errorMessage ? "red" : "#ddd",
      marginBottom: marginb,
      boxShadow: "none",
      // overwrittes hover style
      "&:hover": {
        borderColor: state.isFocused ? "blue" : errorMessage ? "red" : "#ddd",
      },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  return (
    <div className="form-group ">
      <Select
        isDisabled={disable ? disable : false}
        isMulti={mode}
        isClearable
        key="gender-score-filter"
        className="basic-single"
        classNamePrefix="select"
        name={"gender-score-filter"}
        value={selectedValue}
        options={selectOptions}
        defaultValue={defaultValue}
        onChange={onChange}
        styles={customStyles}
        filterOption={filterOptions}
        formatOptionLabel={formatOptionLabel}
        placeholder={placeholderText ? placeholderText : "Select..."}
        menuPortalTarget={menuPortalTarget}
        id={id}
      />
      {/* {errorMessage && (
        <span
          className="text-danger"
          style={{ fontWeight: "normal", paddingLeft: "5px" }}
        >
          {errorMessage}
        </span>
      )} */}
    </div>
  );
};

export default MyCustomSelect;
